module.exports = __webpack_public_path__ + "img/newsImg3-7.ff99da06.png";